import { useI18n } from '../../i18n'
import { useAdminAppManagers } from './useAdminAppManagers'
import { useAdminAppState } from './useAdminAppState'
import { useAdminAppOrchestration } from './model/useAdminAppOrchestration'
import { useAdminAppSlicesComposer } from './model/useAdminAppSlicesComposer'

export const useAdminAppModel = () => {
  const { t } = useI18n()
  const state = useAdminAppState()

  const managers = useAdminAppManagers({
    token: state.token,
    authHeaders: state.authHeaders,
    setSection: state.setSection,
  })

  const { isAuthenticated, handleLogin, logout, currentSession } = useAdminAppOrchestration({
    t,
    state,
    managers,
  })

  return useAdminAppSlicesComposer({
    state,
    managers,
    auth: {
      isAuthenticated,
      handleLogin,
      logout,
    },
    currentSession,
  })
}
